import { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from '@hooks';

import { FilterOption } from '@components/listing';
import { Caption2 } from '@components/styles/Typography';

const FilterAccordion = ({
    filterData,
    selectedFilterCount,
    initalState = false,
}) => {
    const { locale } = useTranslation();
    const [isOpen, setIsOpen] = useState(initalState);
    const { name, attributes, id, slug, query_param: queryParam } = filterData;
    const handleClick = () => setIsOpen(!isOpen);

    return (
        <div>
            <FilterButton onClick={handleClick} isOpen={isOpen}>
                <Caption2 uppercase>
                    {name[locale]}
                    {selectedFilterCount > 0 && `(${selectedFilterCount})`}
                </Caption2>
                <Caption2 />
            </FilterButton>

            {isOpen && (
                <OptionsWrapper>
                    {attributes.map((option) => (
                        <FilterOption
                            key={option.id}
                            queryID={option.id}
                            filterName={name[locale]}
                            filterID={id}
                            queryParam={queryParam}
                            name={option?.name && option?.name[locale]}
                            hexCode={option?.hex_code}
                            slug={slug?.en}
                        />
                    ))}
                </OptionsWrapper>
            )}
        </div>
    );
};
const FilterButton = styled.button`
    background: transparent;
    border: none;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: uppercase;
    margin-top: 16px;
    padding: 10px 0;
    cursor: pointer;

    span:last-child {
        position: relative;
        width: 16px;
        height: 16px;
        ::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 16px;
            height: 1.2px;
            background: ${({ theme }) => theme.colors.primary};
            transform: translate(-50%, -50%);
        }
        ::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 1.2px;
            height: 16px;
            background: ${({ theme }) => theme.colors.primary};
            transform: ${({ isOpen }) =>
                isOpen
                    ? 'translate(-50%, -50%) rotate(90deg)'
                    : 'translate(-50%, -50%) rotate(0deg)'};
            transition: all 0.2s ease-in-out;
        }
    }
`;
const OptionsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 0 6px;
    min-height: 100px;

    @media (max-width: 1024px) {
        padding: 0;
    }
`;

export default FilterAccordion;
